<plugins-notice
  type="toast-float"
  [color]="data.color ?? ''"
  (dismiss)="onClose()"
  *ngIf="showToast"
  @toast
  (@toast.done)="onAnimationDone()"
>
  {{ data.message }}
</plugins-notice>
